import { type AppState } from '../rootReducer';

export const getCurrentToast = (state: AppState) => state.toasts.currentToast;
